<svg
  [attr.viewBox]="store.getViewBoxString$(isInsideZoomPanel) | async"
  [class.round-container]="isInsideZoomPanel"
  [attr.preserveAspectRatio]="preserveAspectRatio"
  [style.opacity]="layerOpacity$ | async"
  (mousedown)="handleMouseEvent($event)"
  (mousemove)="handleMouseEvent($event)"
  (click)="handleMouseEvent($event)"
  (dblclick)="handleMouseEvent($event)"
  (wheel)="handleMouseEvent($event)"
  (mouseup)="handleMouseEvent($event)"
>
  <foreignObject
    #container
    [attr.width]="store('sensorRendererState')('width').$ | async"
    [attr.height]="store('sensorRendererState')('height').$ | async"
  ></foreignObject>

  <g [attr.transform]="translate">
    <ng-container *ngFor="let shapeStore of shapeStores$ | async">
      @if (!shapeStore.state().isProjection) {
        <ng-container [ngSwitch]="shapeStore('type').$ | async">
          <g
            *ngSwitchCase="'arrow'"
            h3Arrow
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'cuboid'"
            h3Cuboid
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'hair'"
            h3Hair
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'keypoint_shape'"
            h3KeypointShape
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'line'"
            h3Line
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'model_input_points'"
            h3ModelInputPoints
            [shapeStore]="shapeStore"
          />
          <g
            *ngSwitchCase="'point'"
            h3Point
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'polygon'"
            h3Polygon
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'rectangle'"
            h3Rectangle
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
          <g
            *ngSwitchCase="'slider_rectangle'"
            h3SliderRectangle
            [shapeStore]="shapeStore"
            [isInOverlay]="isOverlay"
          />
        </ng-container>
      }
    </ng-container>

    <ng-container
      *ngFor="let transform of missingShapeMarkerTransforms$ | async"
    >
      <g h3MissingShapeFeedbackMarker [attr.transform]="transform" />
    </ng-container>
  </g>
</svg>
